import React, { Component } from "react";
import { connect } from "react-redux";
import { withFirebase } from "../../firebase";
import { updateFirebaseConfig, updateLogin } from "../../reducers/auth";
import Auth from "./auth";
import { withRouter } from "react-router-dom";
import { compose } from "recompose";
import * as ROUTES from "../../constants/routes";
import { AuthUserContext } from "../../sessions";

class AuthContainer extends Component {
	constructor() {
		super();
		this.state = {
			loadStatus: false,
		};
	}

	signIn = async (data) => {
		this.signInAttemptId = (this.signInAttemptId || 0) + 1;
		const attemptId = this.signInAttemptId;
		this.setState({ loadStatus: true });

		const withTimeout = (promise, timeout) => {
			let timeoutId;
			const timeoutPromise = new Promise((_, reject) => {
				timeoutId = setTimeout(() => reject(new Error("timeout")), timeout);
			});

			return Promise.race([promise, timeoutPromise]).finally(() => {
				clearTimeout(timeoutId);
			});
		};
		const prepareAppCheck = async () => {
			if (this.props.firebase.ensureAppCheckToken) {
				await withTimeout(this.props.firebase.ensureAppCheckToken(), 3000);
			}
		};
		const signInOnce = () =>
			withTimeout(
				this.props.firebase.doSignInWithEmailAndPassword(
					data.email,
					data.password
				),
				15000
			);

		try {
			try {
				await prepareAppCheck();
			} catch (error) {}

			try {
				await signInOnce();
			} catch (error) {
				const code = error && error.code ? error.code : "";
				const message = error && error.message ? error.message : "";
				const shouldRetry =
					code === "auth/invalid-app-credential" ||
					code === "auth/network-request-failed" ||
					/app\s?check/i.test(message) ||
					message === "timeout";

				if (!shouldRetry) throw error;
				try {
					await prepareAppCheck();
				} catch (appCheckError) {}
				await signInOnce();
			}

			if (attemptId !== this.signInAttemptId) return;
			const login = localStorage.getItem("@login");
			if (login) this.props.updateLogin(login);
			this.props.history.push(ROUTES.DEFAULT);
		} catch (error) {
			if (attemptId === this.signInAttemptId) {
				alert("Ошибка! Попробуйте еще раз!");
			}
		} finally {
			if (attemptId === this.signInAttemptId) {
				this.setState({ loadStatus: false });
			}
		}
	};

	signOut = async () => {
		this.props.history.push(ROUTES.SIGN_IN);

		try {
			await this.props.firebase.doSignOut();
		} catch (error) {}

		localStorage.removeItem("@login");
		localStorage.removeItem("adminPermission");
		localStorage.removeItem("chosenCity");
		localStorage.removeItem("chosenBrand");
		localStorage.removeItem("currentBrand");
		localStorage.removeItem("currentCity");
		this.props.updateFirebaseConfig(null);
		this.props.updateLogin(null);
	};

	render() {
		console.log("authUser props", this.props);
		return (
			<AuthUserContext.Consumer>
				{(authUser) =>
					authUser ? (
						this.props.history.push(ROUTES.DEFAULT)
					) : (
						<Auth
							onSubmit={this.signIn}
							loadStatus={this.state.loadStatus}
							onReturn={this.signOut}
						/>
					)
				}
			</AuthUserContext.Consumer>
		);
	}
}

const AuthNext = compose(withFirebase, withRouter)(AuthContainer);

export default connect(null, { updateFirebaseConfig, updateLogin })(AuthNext);
